module.exports = __webpack_public_path__ + "img/listing-inactive.26861af6.svg";